// extracted by mini-css-extract-plugin
export var assigneeBadge = "_n6-0";
export var assigneeDetails = "_n6-1";
export var assigneeInfo = "_n6-2";
export var dropdownContainer = "_n6-4";
export var dropdownImage = "_n6-5";
export var editAssigneeInfo = "_n6-3";
export var editAssigneeModalContainer = "_n6-6";
export var hidden = "_n6-8";
export var input = "_n6-7";